//deps
import { clickDeliveryFeeLineItem } from "@cart-client/analytics/events";
import { AnalyticsEventPayload } from "@swiggy-private/analytics";
import { PlanDetails, RenderingDetails } from "@swiggy-private/cart-types";
import { FlowType } from "@swiggy-private/super-ui";
import React from "react";
import { isSwiggyBlackPlanVariants } from "./SwiggyPlanBullsEyeTg";
import { isEmpty } from "@swiggy-private/js-utils";

type renderHalfcardProps = {
    setShowM2ChalfcardOnClick: React.Dispatch<React.SetStateAction<{ status: boolean; flowType: FlowType }>>;
    setBillDetailsOneCardComms?: () => void;
    clickEvent: (payload: AnalyticsEventPayload) => void;
    planDetails?: PlanDetails;
    itemData?: RenderingDetails;
};

export function renderHalfcardOnMakeItFreeClick({
    setShowM2ChalfcardOnClick,
    setBillDetailsOneCardComms,
    clickEvent,
    planDetails,
    itemData,
}: renderHalfcardProps) {
    clickDeliveryFeeLineItem(clickEvent, itemData?.meta?.valueCtaText || "--", planDetails);
    if (!isEmpty(planDetails) && isSwiggyBlackPlanVariants(planDetails)) {
        setShowM2ChalfcardOnClick({ status: true, flowType: FlowType.FREEDEL_HALF_CARD });
    } else {
        setBillDetailsOneCardComms?.();
    }
}
